<template>
  <el-dialog
    v-model="visibleDialog"
    width="600px"
    title="修改系统名称以及更换logo"
    @close="handleClose"
    @open="handleOpen"
    :append-to-body="true"
  >
    <el-form
      ref="formRef"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="系统名称：" prop="systemName">
        <el-input v-model="formData.systemName" maxlength="20" placeholder="请输入系统名称"/>
      </el-form-item>
      <el-form-item label="logo：" prop="systemLogo">
        <UploadImg v-model:value="formData.systemLogo"></UploadImg>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </template>
  </el-dialog>
</template>
<script setup>
import {ref, reactive, defineProps, defineEmits, watch} from 'vue'
import {ElMessage} from "element-plus";
import UploadImg from "@/components/uploadImg/index.vue";
import {getSystemInfo, systemAddOrUpdate} from "@/api/apiSystem";
import emitter from "@/utils/eventBus";
// 接收父组件传递的 visible 属性
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:visible'])
// 表单数据
const formData = reactive({
  id:"",
  systemName: '',
  systemLogo:""
})

// 表单验证规则
const formRules = reactive({
  systemName: [
    {required: true, message: '请输入系统名称', trigger: 'blur'}
  ],
  systemLogo: [
    {required: true, message: '请上传logo', trigger: 'blur'},
  ]
})

// 表单引用
const formRef = ref(null)
// 本地 visible 状态（通过 watch 与父组件同步）
const visibleDialog = ref(false)
watch(
  () => props.visible,
  (newVal) => {
    visibleDialog.value = newVal
  },{
    immediate: true,
    deep: true,
  }
)
const handleOpen=async ()=>{
  //查询系统名称
  const {code,data}=await getSystemInfo();
  if(code===200){
    Object.assign(formData, data)
  }
}
const handleClose = () => {
  formRef.value?.resetFields();
  emit('update:visible', false)    // 关闭弹窗
}
// 提交处理
const handleSubmit = async () => {
  await formRef.value.validate(async (valid) => {
    if (valid) {
      const {code}=await systemAddOrUpdate(formData);
      if (code === 200) {
        ElMessage.success('保存成功！');
        //修改系统名称
        emitter.emit('againGetSystemInfo');
        emit('update:visible', false)    // 关闭弹窗
      } else {
        ElMessage.error('保存失败！');
      }
    }
  })
}
</script>

<style lang="scss" scoped>

</style>
